import { instantsInterceptor, } from '@/api/index';

function getRelatedLinkList() {
    return instantsInterceptor.get('/relatedlink/list');
}

function getRelatedLink(link) {
    return instantsInterceptor.post('/mgmt/relatedlink/detail', link);
}

function saveRelatedLink(link) {
    return instantsInterceptor.post('/mgmt/relatedlink/save', link);
}

function deleteRelatedLink(link) {
    return instantsInterceptor.post('/mgmt/relatedlink/delete', link);
}

function saveNewRelatedLinkSort(linkList) {
    return instantsInterceptor.post('/mgmt/relatedlink/sort/edit', linkList);
}

export {
    getRelatedLinkList,
    getRelatedLink,
    saveRelatedLink,
    deleteRelatedLink,
    saveNewRelatedLinkSort
};